import {
  type CreateOrderData,
  type AmountBreakdown,
  type OrderItem as OrderItemPayPal,
} from '@wix/cashier-core/dist/src/services/PayPal/types';
import { type PaymentBreakdown } from '../../types/PaymentBreakdown';
import { type ShippingContact } from '../../types/Shipping';
import { type PayPalShippingAddress } from '../../types/paypal';
import { type OrderItem } from '../../types/OrderItem';
import { getOrderItemsTotal } from '../../components/Widget/utils/amount';

export interface OrderData {
  paymentAmount: string;
  paymentBreakdown: PaymentBreakdown;
  orderItems: OrderItem[];
  currencyCode: string;
  requestShipping: boolean;
}

/**
 * Transforms data to backend-compatible structure
 * @param data
 */
export function transformOrderDataToPayPal(data: OrderData): CreateOrderData {
  return {
    totalAmount: Number(data.paymentAmount),
    currency: data.currencyCode,
    amountBreakdown: transformPaymentBreakdownToPayPal(data.paymentBreakdown, data.orderItems),
    orderItems: transformOrderItemsToPayPal(data.orderItems),
    requestShipping: data.requestShipping,
  };
}

export function transformPaymentBreakdownToPayPal(
  paymentBreakdown: PaymentBreakdown,
  orderItems: OrderItem[] = [],
): AmountBreakdown {
  if (!paymentBreakdown) {
    return null;
  }

  const itemsTotal = getOrderItemsTotal(orderItems);
  const breakdown: Partial<AmountBreakdown> = {
    itemsTotal,
  };

  Object.entries(paymentBreakdown).forEach(([key, value]) => {
    if (value) {
      breakdown[key] = Number(value);
    }
  });

  return breakdown as AmountBreakdown;
}

export function transformOrderItemsToPayPal(orderItems: OrderItem[] = []): OrderItemPayPal[] {
  return orderItems.map((item) => ({
    ...item,
    price: Number(item.price),
    // https://wix.atlassian.net/browse/PAY-1652
    category: undefined,
  }));
}

export const transformToShippingContact = (data: PayPalShippingAddress): ShippingContact => {
  return {
    countryCode: data.country_code,
    city: data.city,
    postalCode: data.postal_code,
    state: data.state,
  };
};
